import { type ReactNode, createElement } from 'react';

import type {
  FlagContentInterceptor,
  FlagContentRenderer,
} from '@spotify/confidence-flag-evaluation-react';

import { useFlagHighlightEnabled } from './highlightStore';
import {
  FLAG_MARKER_ATTRIBUTE,
  FLAG_MARKER_ENABLED_ATTRIBUTE,
} from './markerAttributes';

export const markFlagContent: FlagContentInterceptor = (
  render: FlagContentRenderer,
): FlagContentRenderer => {
  const useMarkedContent = (
    content: ReactNode,
    flag: string,
    enabled: boolean,
  ): ReactNode => {
    const highlighted = useFlagHighlightEnabled();
    const rendered = render(content, flag, enabled);

    if (!highlighted) {
      return rendered;
    }

    return createElement(
      'span',
      {
        [FLAG_MARKER_ATTRIBUTE]: flag,
        [FLAG_MARKER_ENABLED_ATTRIBUTE]: enabled,
        style: { display: 'contents' },
      },
      rendered,
    );
  };

  return useMarkedContent;
};
